import { render, staticRenderFns } from "./BaseInfoBox.vue?vue&type=template&id=21f43573&"
import script from "./BaseInfoBox.vue?vue&type=script&lang=js&"
export * from "./BaseInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports